import { render, staticRenderFns } from "./DataDefinition.vue?vue&type=template&id=ccf9ae9c&"
import script from "./DataDefinition.vue?vue&type=script&lang=js&"
export * from "./DataDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports